import { Product } from "@/types/product";
import { beautifyPrice } from "@/utils/price";
import { AspectRatio, Box, HStack, Stack, Text, BoxProps, Wrap, WrapItem, Flex } from "@chakra-ui/react";
import Image from "next/image";
import { forwardRef } from "react";
import { I18nLink } from "../i18n/I18nLink";
import { makeProductPageUrl } from "@/utils/product";
import { getImageSrc } from "@/utils/file";
import ProductFavoriteButton from "./ProductFavoriteButton";
import ProductBadge from "./ProductBadge";
// import { $shopState } from "@/shared/store/shop";
// import { useUnit } from "effector-react";

type ProductCardProps = {
  product: Product;
} & BoxProps;

const ProductCard = forwardRef<HTMLDivElement, ProductCardProps>(({ product, ...boxProps }, ref) => {
  // const { cart, favorites } = useUnit($shopState);

  // const isInFavorites = favorites.items.some(item => item.product?.id === product.id);

  const isNew = product?.isNew;
  const salePercent = product?.regularPrice && product.price < product.regularPrice
    ? Math.round((1 - product.price / product.regularPrice) * 100)
    : null;

  return (
    <I18nLink href={makeProductPageUrl(product)} passHref>
      <Box
        ref={ref}
        className="product-card"
        p={"16px"}
        width="100%"
        cursor={"pointer"}
        position={"relative"}
        _hover={
          { backgroundColor: "#f5f5fd" }
        }
        {...boxProps}
      >
        {/* абсолют шапка слева сверху */}
        <Stack direction={"row"} justifyContent={"space-between"} mb={"12px"} position={"absolute"} top={0} left={0} p={"16px"} zIndex={9} w={"100%"}>
          <HStack>
            <Wrap gap="2px">
              {isNew && <WrapItem>
                <ProductBadge type="new" />
              </WrapItem>}
              {salePercent !== null && <WrapItem>
                <ProductBadge type="sale" label={`${salePercent}%`} />
              </WrapItem>}
            </Wrap>
          </HStack>
          <ProductFavoriteButton product={product} minW={"inherit"} height={"inherit"} boxSize={"6"} />
        </Stack>
        <AspectRatio ratio={1} w="100%" maxW="100%">
          <Image
            src={getImageSrc(product, "main")}
            alt={product?.name ?? "Name"}
            width={400}
            height={400}
            quality={30}
            style={{ objectFit: "cover" }}
            className="product-image"
            priority
          />
        </AspectRatio>
        <Stack gap={"12px"}>
          <Stack minHeight={"2.5em"} justifyContent={"flex-end"}>
            <Text
              className="product-name"
              textStyle={"bold16"}
              as={"b"}
              lineHeight={"20px"}
              lineClamp={2}
            >
              {product?.name ?? "Name"}
            </Text>
          </Stack>
          <HStack>
            <Text as={"b"} className="product-price">{beautifyPrice(product?.price)}</Text>
            {product.price < product.regularPrice && <Text as={"del"} className="product-price">{beautifyPrice(product?.regularPrice)}</Text>}
          </HStack>
        </Stack>
      </Box>
    </I18nLink>
  );
});

ProductCard.displayName = "ProductCard";
export default ProductCard;